import { Injectable, Optional } from '@angular/core';
import { Observable, forkJoin, Subject } from 'rxjs';
import { FUploadFileExtend } from '@farris/extend-file-upload';
import { FrameContext, CommandContext, BindingPathConverter, BindingList, BindingObject } from '@farris/devkit';
import { FormNotifyService } from '../form-notify.service';
import { AttachmentInfo, ATTACHMENT_ORDER_FIELD } from './types';
import { AttachmentDataService } from './attachment-data.service';
import { LanguageService } from '../languag.service';
import { EntityService } from '../entity-services/index';
import { ListDataService, SubListDataService } from '../data-services/index';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { debounceTime, tap } from 'rxjs/operators';

/**
 * éä»¶ä¸ä¼ 
 * @summary
 * fileExtendï¼å½åæä»¶ä¸ä¼ æé¢è§ç»ä»¶ä¼ éè¿æ¥çæ°æ®ï¼
 * fileExtendFieldPathï¼å½åéä»¶UDTçå­æ®µè·¯å¾ï¼
 * attachmentInfoï¼å½åéä»¶UDTæéçä¿¡æ¯ï¼
 */
@Injectable()
class FileService {
  private subject: Subject<{ fileInfoFieldPath: string, configs: string }>;
  private attachmentInfos: AttachmentInfo[];
  /**
   * æé å½æ°
   */
  constructor(
    private frameContext: FrameContext,
    private attachDataService: AttachmentDataService,
    private entityService: EntityService,
    private subListDataService: SubListDataService,
    private notifyService: FormNotifyService,
    private languageService: LanguageService,
    private listDataService: ListDataService,
    @Optional() private formLoadingService: FormLoadingService
  ) {
    this.subject = new Subject<{ fileInfoFieldPath: string, configs: string }>();
    this.subject.pipe(debounceTime(500)).subscribe((data: { fileInfoFieldPath: string, configs: string }) => {
      this.process(data.fileInfoFieldPath, data.configs);
    });
    this.attachmentInfos = [];
  }

  // #region ä¸ä¼ æä»¶

  /**
   * æ¹éæ·»å éä»¶è¡
   */
  public addFileRows(fileInfoFieldPath: string) {
    const attachmentInfos = this.getAttachmentInfosToAddFromContext();
    if (attachmentInfos.length === 0) {
      this.notifyService.info('è¯·åä¸ä¼ éä»¶');
    }
    return this.attachDataService.updateRows(fileInfoFieldPath, attachmentInfos);
  }
  /**
   * æ¹éæ·»å å¸¦éä»¶ç±»åçéä»¶è¡
   * @param fileInfoFieldPath éä»¶udtå­æ®µ
   * @param configs éä»¶æ©å±ä¿¡æ¯éç½® 
   * @description configséç½®å¦{"billId":"{UISTATE~/root/billId}","rowId":"{UISTATE~/root/rowId}","attachmentType":"xueli"}
   */
  public addFileRowsWithConfigs(fileInfoFieldPath: string, configs: string) {
    const attachmentInfos = this.getAttachmentInfosToAddFromContext();
    if (attachmentInfos.length === 0) {
      this.notifyService.info('è¯·åä¸ä¼ éä»¶');
    }
    // let mapFields = null;
    // if (typeof configs === 'string') {
    //   // å»æé¦å°¾ç©ºæ ¼
    //   configs = configs.trim();
    // }
    // if (configs.startsWith('{') && configs.endsWith('}')) {
    //   try {
    //     mapFields = JSON.parse(configs);
    //   } catch {
    //     throw new Error('éä»¶æ©å±ä¿¡æ¯éç½®ä¸æ¯åæ³çjsonå­ç¬¦ä¸²ã');
    //   }
    // } else {
    //   throw new Error('éä»¶æ©å±ä¿¡æ¯éç½®ä¸æ¯åæ³çjsonå­ç¬¦ä¸²ã');
    // }
    this.attachmentInfos = this.attachmentInfos.concat(attachmentInfos);
    this.subject.next({ fileInfoFieldPath, configs });
    //return this.attachDataService.updateRowsWithConfigs(fileInfoFieldPath, attachmentInfos, mapFields);
  }
  private process(fileInfoFieldPath: string, configs: string) {
    if (this.attachmentInfos && this.attachmentInfos.length > 0) {
      const attachmentInfos = this.attachmentInfos.concat([]);
      let mapFields = null;
      if (typeof configs === 'string') {
        // å»æé¦å°¾ç©ºæ ¼
        configs = configs.trim();
      }
      if (configs.startsWith('{') && configs.endsWith('}')) {
        try {
          mapFields = JSON.parse(configs);
        } catch {
          throw new Error('éä»¶æ©å±ä¿¡æ¯éç½®ä¸æ¯åæ³çjsonå­ç¬¦ä¸²ã');
        }
      } else {
        throw new Error('éä»¶æ©å±ä¿¡æ¯éç½®ä¸æ¯åæ³çjsonå­ç¬¦ä¸²ã');
      }
      this.attachDataService.updateRowsWithConfigs(fileInfoFieldPath, attachmentInfos, mapFields).pipe(
        tap(() => {
          this.attachmentInfos = this.attachmentInfos.filter(item => !attachmentInfos.find(attachmentInfo => attachmentInfo.attachmentId === item.attachmentId));
          if (this.attachmentInfos.length > 0) {
            this.process(fileInfoFieldPath, configs);
          }
        })
      ).subscribe();
    }

  }

  /**
   * è·åè¦æ·»å çéä»¶ä¿¡æ¯æ°ç»
   */
  private getAttachmentInfosToAddFromContext(): AttachmentInfo[] {
    const fileExtends = this.getFileExtendsFromContext();
    const attachmentInfos = this.convertToAttachmentInfos(fileExtends);
    return attachmentInfos;
  }

  /**
   * å°éä»¶ä¸ä¼ ç»ä»¶è¿åçéä»¶ä¿¡æ¯è½¬æ¢ä¸ºæå¡å¨ç«¯éè¦çæ ¼å¼
   */
  private convertToAttachmentInfos(fileExtends: FUploadFileExtend[]): AttachmentInfo[] {
    if (!fileExtends) {
      return [];
    }

    const attachmentInfos: AttachmentInfo[] = [];
    fileExtends.forEach((fUploadOutPut: FUploadFileExtend) => {
      const attachmentInfo: AttachmentInfo = {
        attachmentId: fUploadOutPut.extend.metadataId,
        fileName: fUploadOutPut.extend.fileName,
      };
      attachmentInfos.push(attachmentInfo);
    });
    return attachmentInfos;
  }

  // #endregion


  // #region å é¤æä»¶

  /**
   * å é¤éä»¶è¡
   */
  public removeFileRows(fileInfoFieldPath: string): Observable<any> {
    const dataIds = this.getDataIdsToRemoveFromContext(fileInfoFieldPath);
    if (dataIds.length === 0) {
      this.notifyService.info('è¯·éæ©è¦å é¤çéä»¶');
    }
    const isSublist = fileInfoFieldPath.split('/').filter(p => p).length >= 2;
    const removeObservables: Observable<any>[] = [];
    if (isSublist) {
      dataIds.forEach((dataId: string) => {
        let removeObservable;
        removeObservable = this.subListDataService.removeWithoutConfirm(dataId);
        removeObservables.push(removeObservable);
      });
      return forkJoin(removeObservables);
    } else {
      return this.listDataService.removeRows(dataIds, false, null, false);
    }
  }

  /**
   * è·åè¦å é¤çæ°æ®
   */
  private getDataIdsToRemoveFromContext(fileExtendFieldPath: string): string[] {

    // ä»ä¸ä¸æä¸­è·åè¦å¤ççéä»¶ä¿¡æ¯æ°ç»
    const fileExtends = this.getFileExtendsFromContext();

    // å°éä»¶æ°ç»è½¬æ¢ä¸ºå¯¹åºçæ°æ®id
    const dataIds: string[] = [];
    fileExtends.forEach((fileExtend: FUploadFileExtend) => {

      // ä¸ä¼ å é¤åé¢è§å é¤ä¼ éè¿æ¥çfileIdçkeyå¯è½ä¸ä¸è´ï¼è¦åå¼å®¹
      const fileId = fileExtend.extend.metadataId;
      const dataId = this.convertFileIdToDataId(fileId, fileExtendFieldPath);
      dataIds.push(dataId);
    });
    return dataIds;
  }

  /**
   * æ ¹æ®è·¯å¾è·åéä»¶å­æ®µå¼æ°ç»
   * @param fieldPath å­æ®µè·¯å¾
   */
  private convertFileIdToDataId(fileId: string, fileExtendFieldPath: string): string {

    // è§£æè·¯å¾
    const fileBindingPath = BindingPathConverter.toBindingPathArray(fileExtendFieldPath);
    const fileFieldName = fileBindingPath.pop();
    const fileListBindingPath = fileBindingPath;

    // è·åéä»¶idæ°ç»
    const entityListData = this.entityService.getEntityListData(fileListBindingPath);
    const targetEntityData = entityListData.find((entityData: any) => {
      if (entityData[fileFieldName]) {
        const attachmentId = entityData[fileFieldName]['attachmentId'];
        if (attachmentId === fileId) {
          return true;
        }
      }
    });

    return targetEntityData.id;
  }

  // #endregion
  //#region æä»¶æåº
  /**
   * æ´æ°éä»¶æåº
   * @param attachmentInfoFieldPath éä»¶udtå­æ®µè·¯å¾
   * @param ids éä»¶æåºåçéä»¶idæ°ç»
   */
  public updateOrder(attachmentInfoFieldPath: string, ids: string[]) {
    if (!attachmentInfoFieldPath) {
      throw new Error('éä»¶udtå­æ®µè·¯å¾åæ°ä¸è½ä¸ºç©º');
    }
    // æ¯æä»ä»£ç ä¸­ç´æ¥è°ç¨ï¼å¦æåæ°ä¸­ä¼ éäºidsåä½¿ç¨ï¼å¦åä½¿ç¨å½ä»¤ä¸ä¸æä¸­çäºä»¶åæ°
    if (!ids) {
      // è·åäºä»¶åæ°
      const commandContext = this['context'] as CommandContext;
      // ä¸ç»ä»¶çº¦å®äºä»¶åæ°ä¸ºæ°æ®ä¸»é®æ°ç»
      ids = commandContext && commandContext.eventParam && commandContext.eventParam.data;
    }
    // å¯¹æ¶éçä¸»é®æ°ç»è¿è¡å¤æ­
    if (!ids || !Array.isArray(ids)) {
      return;
    }
    // å½åå½ä»¤æå¨ç»ä»¶çç»å®æ°æ®
    const bindingList: BindingList = this.frameContext.bindingData.getList();
    // æ ç»å®æ°æ®æ¶ä¸å¤ç
    if (!bindingList || bindingList.length < 1) {
      return;
    }
    // ç»ä¸è·åéä»¶udtä¿¡æ¯
    const parentBindingPathArray = BindingPathConverter.toBindingPathArray(attachmentInfoFieldPath);
    const attachmentField = parentBindingPathArray.pop();
    // åºç°udtå­æ®µä¸å­å¨çæåµï¼è¯´æå½ä»¤ä¸­éä»¶udtå­æ®µéç½®éè¯¯ævoä¸­æ²¡æéä»¶udtãæ§å¶å¨ä¸å¼å®¹éè¯¯ï¼æ­¤å¤å¤æ­åªä¸ºé»æ­¢åç»­çéå
    if (!attachmentField) {
      throw new Error('æ æ³è·åéä»¶udtå­æ®µï¼è¯·ç¡®è®¤å½ä»¤ä¸­éä»¶udtå­æ®µè·¯å¾éç½®æ­£ç¡®ï¼ä¸è§å¾æ¨¡åä¸­å­å¨éä»¶udtå­æ®µ');
    }
    const data = bindingList.toJSON();
    // æ´æ°ç»å®æ°æ®ä¸­éä»¶udtå­æ®µä¸­æåºå­æ®µçå¼,ä»æ´æ°æéä»¶çè¡
    ids.forEach((id: string, index: number) => {
      const item = data.find(item => item && item[attachmentField] && item[attachmentField]['attachmentId'] === id);
      const primaryKeyValue = item && item.id;
      if (!primaryKeyValue) {
        return;
      }
      const bindingObject = bindingList.findById(primaryKeyValue);
      if (bindingObject) {
        // éä»¶udtå¯¹è±¡
        const attachment = bindingObject[attachmentField] as BindingObject;
        if (attachment) {
          // è·åæ§å¼
          const order = attachment.getValue(ATTACHMENT_ORDER_FIELD);
          if (order !== index) {
            // æ´æ°æåº
            attachment.setValue(ATTACHMENT_ORDER_FIELD, index, true, true);
          }
        }
      }
    });
  }
  //#endregion

  // #region å¶ä»å·¥å·æ¹æ³

  /**
   * ä»ä¸ä¸æä¸­è·åè¦å¤ççéä»¶ä¿¡æ¯æ°ç»
   * @summary
   * ä¸ºäºç»ä¸åä¸ªåå¤ä¸ªéä»¶çå¤çæ¹å¼ï¼ç»ä¸åè£ä¸ºæ°ç»
   */
  private getFileExtendsFromContext(): FUploadFileExtend[] {

    const commandContext = this['context'] as CommandContext;
    const eventParam = commandContext.eventParam;
    if (!eventParam) {
      return [];
    }

    let fileExtends: any[];
    if (Array.isArray(eventParam) === false) {
      fileExtends = [eventParam];
    } else {
      fileExtends = eventParam.concat([]);
    }

    return fileExtends as FUploadFileExtend[];
  }
  // #endregion
}

export { FileService };
